#### `AdvertisementDetails` limit lowered

The maximum size of the [`AdvertisementDetails` position description] has been lowered from 20,000 bytes to 15,000 bytes in UTF-8 encoding.
This aligns the SEEK API with the corresponding limit on the [SEEK Employer website].

Our analysis of job posting behaviour over the past 6 months indicates that fewer than 0.005% of job ads would be affected.
If your software includes validations for the previous limit you’re encouraged to update to the new limit.

[`advertisementdetails` position description]: /schema/named-type/PositionFormattedDescriptionInput
[seek employer website]: https://employer.seek.com
